import { render, staticRenderFns } from "./ModalInfoAppAgendaDemo.vue?vue&type=template&id=fe0d75ca&scoped=true"
import script from "./ModalInfoAppAgendaDemo.vue?vue&type=script&lang=js"
export * from "./ModalInfoAppAgendaDemo.vue?vue&type=script&lang=js"
import style0 from "./ModalInfoAppAgendaDemo.vue?vue&type=style&index=0&id=fe0d75ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0d75ca",
  null
  
)

export default component.exports